import { type ThemeTokens } from '../../theme/tokens';

interface BtnProps {
  children: React.ReactNode;
  primary?: boolean;
  small?: boolean;
  onClick?: () => void;
  t: ThemeTokens;
}
export function Btn({ children, primary, small, onClick, t }: BtnProps) {
  return (
    <button type="button" onClick={onClick} style={{
      display: "inline-flex", fontSize: small ? 11 : 12,
      padding: small ? "5px 12px" : "8px 18px", borderRadius: 99,
      cursor: "pointer",
      background: primary ? t.accentBg : t.surface,
      border: `1px solid ${primary ? t.accentBorder : t.border2}`,
      color: primary ? t.accentText : t.text2,
      marginRight: 6, marginBottom: 4,
      fontFamily: "inherit", lineHeight: "inherit",
    }}>{children}</button>
  );
}
